import { IAttachment } from "interfaces/Attachments";

export type SelectOption<T> = {
  label: string;
  value: T;
};

export const IndexedCategories = [
  "notFound",
  "damage",
  "internalDamage",
  "doors",
  "window",
];

export namespace AttachmentCategory {
  export type Vehicle = "vehicle" | "notFound" | "damage";
  export type Patrimony = "external" | "internal" | "internalDamage";
  export type Indexed = "notFound" | "damage" | "internalDamage";
}

export namespace AttachmentCaptionList {
  export type Vehicle = {
    [key in AttachmentCategory.Vehicle]: SelectOption<string>[];
  };

  export type Patrimony = {
    [key in AttachmentCategory.Patrimony]: SelectOption<string>[];
  };
}

const patrimonyAttachmentCategory: SelectOption<AttachmentCategory.Patrimony>[] =
  [
    {
      label: "Fotos externas do local",
      value: "external",
    },
    {
      label: "Fotos internas do local",
      value: "internal",
    },
    {
      label: "Fotos dos possíveis danos internos",
      value: "internalDamage",
    },
  ];

const vehicleAttachmentCategory: SelectOption<AttachmentCategory.Vehicle>[] = [
  {
    label: "Veiculo não encontrado",
    value: "notFound",
  },
  {
    label: "Veiculo encontrado",
    value: "vehicle",
  },
  {
    label: "Eventuais danos ao veículo",
    value: "damage",
  },
];

const vehicleCaptionOptions: AttachmentCaptionList.Vehicle = {
  vehicle: [
    {
      label: "Dianteira identificando a placa",
      value: "front",
    },
    {
      label: "Lateral esquerda",
      value: "leftSide",
    },
    {
      label: "Lateral direita",
      value: "rightSide",
    },
    {
      label: "Traseira identificando a placa",
      value: "back",
    },
  ],
  damage: [
    {
      label: "Eventual dano",
      value: "damage",
    },
  ],
  notFound: [
    {
      label: "Foto do local onde o carro estava",
      value: "notFound",
    },
  ],
};

const patrimonyCaptionOptions: AttachmentCaptionList.Patrimony = {
  external: [
    {
      label: "Fachada / frente",
      value: "front",
    },
    {
      label: "Lateral esquerda",
      value: "leftSide",
    },
    {
      label: "Lateral direita",
      value: "rightSide",
    },
    {
      label: "Fundos",
      value: "back",
    },
    {
      label: "Fechadura de portas ou portões",
      value: "doors",
    },
    {
      label: "Janelas fechadas ou abertas",
      value: "window",
    },
  ],
  internal: [
    {
      label: "Interior do local",
      value: "internal",
    },
  ],
  internalDamage: [
    {
      label: "Dano no interior do local",
      value: "internalDamage",
    },
  ],
};

type IAttachmentCategories = {
  patrimony: SelectOption<AttachmentCategory.Patrimony>[];
  vehicle: SelectOption<AttachmentCategory.Vehicle>[];
};

export const AttachmentCategories: IAttachmentCategories = {
  patrimony: patrimonyAttachmentCategory,
  vehicle: vehicleAttachmentCategory,
};

type IAttachmentCaptions = {
  patrimony: AttachmentCaptionList.Patrimony;
  vehicle: AttachmentCaptionList.Vehicle;
};

export const AttachmentCaptions: IAttachmentCaptions = {
  patrimony: patrimonyCaptionOptions,
  vehicle: vehicleCaptionOptions,
};

type TreatAttachmentLocationParams = {
  attachments: IAttachment[];
  location: string;
};

export function treatAttachmentLocation({
  attachments,
  location,
}: TreatAttachmentLocationParams) {
  const categoryAttachmentList = attachments.filter((attachment) =>
    attachment.location.includes(location)
  );

  return `${location}_${categoryAttachmentList.length + 1}`;
}

type GetActualPhotoParams = {
  attachments: IAttachment[];
  location: string;
};

export function getActualPhoto({
  attachments,
  location,
}: GetActualPhotoParams) {
  return attachments.find((el) => el.location === location);
}

export type CategoryCaptions = {
  [key in AttachmentCategory.Patrimony | AttachmentCategory.Vehicle]: string;
};

export const categoryCaptions: CategoryCaptions = {
  vehicle: "Foto do veículo",
  damage: "Foto do dano ao veículo",
  notFound: "Foto do local onde o veiculo estava",
  external: "Foto do exterior do patrimônio",
  internal: "Foto do interior do patrimônio",
  internalDamage: "Foto do dano interno ao patrimônio",
};
